/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/scan'
export default icon
